export default __webpack_public_path__ + "static/media/Фос_1л.d2d747bb.jpg";